export default __webpack_public_path__ + "static/media/s15.bb33a0b1.png";